/* eslint-disable react/prop-types */
import { useEffect } from "react";

/**
 * Centered, friendly popup shown when the server rate-limits a request (HTTP 429).
 * Replaces the raw DRF "Request was throttled. Expected available in N seconds."
 * message with something a non-technical user understands.
 */
const RateLimitModal = ({ open, onClose, message, title = "Just a moment" }) => {
  // Close on Escape
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center px-4 font-poppins"
      role="dialog"
      aria-modal="true"
    >
      {/* backdrop */}
      <div
        className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* card */}
      <div className="relative w-full max-w-sm rounded-2xl bg-white shadow-2xl overflow-hidden animate-[rlpop_0.25s_ease-out]">
        {/* gradient header band */}
        <div
          className="h-24 flex items-center justify-center"
          style={{ background: "linear-gradient(135deg,#8B1FD9,#C026D3)" }}
        >
          <div className="w-16 h-16 rounded-full bg-white/15 backdrop-blur flex items-center justify-center">
            <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 7v5l3 2" />
            </svg>
          </div>
        </div>

        <div className="px-7 py-6 text-center">
          <h2 className="text-xl font-semibold text-slate-800 mb-2">{title}</h2>
          <p className="text-[15px] leading-relaxed text-slate-500 mb-6">
            {message}
          </p>
          <button
            onClick={onClose}
            className="w-full py-3 rounded-xl text-white font-semibold shadow-lg shadow-violet-200 hover:opacity-90 transition-all"
            style={{ background: "linear-gradient(135deg,#8B1FD9,#C026D3)" }}
          >
            Got it
          </button>
        </div>
      </div>

      <style>{`
        @keyframes rlpop {
          from { opacity: 0; transform: scale(0.94) translateY(8px); }
          to   { opacity: 1; transform: scale(1) translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default RateLimitModal;
